
import UnblockUserDialog from '@/components/block/UnblockUserDialog.vue'
import blockUserMixin from '@/mixins/blockUser'

const DEFAULT_AVATAR = require('@/assets/image/global/default-avatar.png')
const PAGE_SIZE_DEFAULT = 20 // 与接口固定 page_size 对齐

export default {
  name: 'BlacklistPanel',
  components: { UnblockUserDialog },
  mixins: [blockUserMixin],
  data() {
    return {
      list: [], // BlocklistItem[]
      total: 0, // 有效 active 关系总数，只认接口 data.total
      page: 1,
      pageSize: PAGE_SIZE_DEFAULT,
      listLoading: false,
      loadError: false, // 失败时保留当前 list，展示重试
      unblockingUid: null, // 当前正在移出的 uid，防止重复点击
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    /** 拉取黑名单列表；失败保留现有数据 */
    async fetchList() {
      if (this.listLoading) return
      this.listLoading = true
      this.loadError = false
      try {
        const res = await this.$global.userBlockList({ page: this.page })
        if (res.code === 200 && res.data) {
          this.list = Array.isArray(res.data.list) ? res.data.list : []
          this.total = Number(res.data.total) || 0
          this.page = Number(res.data.page) || this.page
          this.pageSize = Number(res.data.page_size) || PAGE_SIZE_DEFAULT
          // 当前页删光后若还有总数，回退上一页；否则空态
          if (!this.list.length && this.total > 0 && this.page > 1) {
            this.page -= 1
            this.listLoading = false
            await this.fetchList()
            return
          }
        } else {
          this.loadError = true
          this.$message.error((res && res.msg) || this.$t('page.UNKNOWN_ERROR'))
        }
      } catch (e) {
        this.loadError = true
        this.$message.error(this.$t('page.UNKNOWN_ERROR'))
      } finally {
        this.listLoading = false
      }
    },
    retryFetch() {
      this.fetchList()
    },
    handlePageChange(page) {
      this.page = page
      this.fetchList()
    },
    /** 无头像时用默认图；已注销由服务端返回空 face_url */
    resolveAvatar(item) {
      return (item && item.face_url) || DEFAULT_AVATAR
    },
    /** 无昵称视为已注销用户，展示本地化文案 */
    resolveNickname(item) {
      const name = item && item.nickname
      if (name === undefined || name === null || String(name).trim() === '') {
        return this.$t('page.DELETED_USER')
      }
      return name
    },
    onAvatarError(e) {
      e.target.src = DEFAULT_AVATAR
    },
    /** blocked_at 为秒级时间戳，展示为本地日期 */
    formatBlockedAt(ts) {
      if (!ts) return ''
      const dt = new Date(Number(ts) * 1000)
      if (Number.isNaN(dt.getTime())) return ''
      const y = dt.getFullYear()
      const m = String(dt.getMonth() + 1).padStart(2, '0')
      const d = String(dt.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    /**
     * 移出黑名单：先二次确认，成功后从当前页移除；删光最后一项则切空态。
     * @param {{ uid: number, nickname?: string, face_url?: string }} item
     */
    async handleUnblock(item) {
      if (!item || !item.uid || this.unblockingUid) return
      this.unblockingUid = item.uid
      try {
        await this.openUnblockDialog({
          target_user_id: item.uid,
          nickname: item.nickname,
          avatar: item.face_url,
        })
        this.list = this.list.filter((row) => row.uid !== item.uid)
        this.total = Math.max(0, this.total - 1)
        if (!this.list.length) {
          if (this.total > 0 && this.page > 1) {
            this.page -= 1
            await this.fetchList()
          } else {
            this.total = 0
          }
        }
      } catch (e) {
        // 取消、失败（弹窗内已提示）或未登录：保留该行与已拉黑态
      } finally {
        this.unblockingUid = null
      }
    },
  },
}
